import { call, put, takeLatest, select } from 'redux-saga/effects';
import { LocalError } from 'helpers/errorTypes';
import ApiService from 'services/ApiService';
import App from 'modules/App';
import { accountCCAccessToken } from 'modules/Account/selectors';
import * as actionTypes from './actionTypes';
import * as actions from './actions';
import messages from './messages';
function* getMe() {
    try {
        const token = yield select(accountCCAccessToken);
        if (!token) {
            const err = new LocalError({
                code: 'NoContourCloudAccessToken'
            });
            yield put(actions.getMeError(err));
            yield call(App.dispatchError, err, messages);
            return;
        }
        const options = {};
        if (token) {
            const { accessToken } = token;
            if (accessToken) {
                options.headers = {
                    ContourCloudAccessToken: accessToken
                };
            }
        }
        const requestUrl = '/api/ContourCloud/me';
        const profile = yield call(ApiService.regionalRequest, requestUrl, options);
        yield put(actions.getMeSuccess(profile));
    } catch (err) {
        yield put(actions.getMeError(err));
        if (err && err.status === 401) {
            err.status = 400;
        }
        yield call(App.dispatchError, err, messages);
    }
}
function* sagas() {
    yield takeLatest(actionTypes.CONTOUR_CLOUD_ME, getMe);
}
export default [
    sagas
];
